









import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import QrInitInfo from "../qr/QrInitInfo.vue";
import {PhoneNumber} from "../../modules/models";

@Component({
    components: {
        "init-info": QrInitInfo,
    }
})
export default class QrStartInfo extends CommonBase {
    @Prop()
    phone!: PhoneNumber;
    @Prop({default: ""})
    redir!: string;

    get qrSignupTo() {
        return {name: "signupqr", params: {countrycode: ""+this.phone.countrycode, number: ""+this.phone.number}, query: {redir: this.redir}};
    }
}
